import React, { Component }  from 'react';
import {format} from 'react-string-format';
import Game from "./Game";
import * as ReactDOM from 'react-dom';
import {NavLink} from "react-router-dom";
import {withRouter} from "./withRouter";
import {Card, Col, Container, ListGroup, Row} from "react-bootstrap";
import {TwitterShareButton} from "react-share";

class Genre extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            isLoaded: false,
            items: []
        };
    }

    componentDidMount() {
        if(this.props.genre) {
            fetch(process.env.REACT_APP_API_URL + "/customer/game?filters[genre]=" + this.props.genre)
                .then(res => res.json())
                .then(
                    (result) => {
                        this.setState({
                            isLoaded: true,
                            items: result.data
                        });
                    },
                    // Note: it's important to handle errors here
                    // instead of a catch() block so that we don't swallow
                    // exceptions from actual bugs in components.
                    (error) => {
                        this.setState({
                            isLoaded: true,
                            error
                        });
                    }
                )
        }
    }

    render() {
        const { error, isLoaded, items } = this.state;

        var content = null;

        if (error) {
            content = <div>{error ? <div className="alert alert-danger">
                <p>Session token has expired. Please, <a href="/account">login</a> again</p>
            </div> :<empty/>}</div>;
        } else if (!isLoaded) {
            content = <div>Loading...</div>;
        } else {
            content = (
                <div id="root">
                    <h1>{this.props.genre.toUpperCase()}</h1>
                    <br/>
                    {items.filter(item => (['active', 'in_review', 'update_in_review'].includes(item.status))).map(item => (
                        <div>
                            <Card style={{ width: '100%' }}>
                                <Card.Img width="100%" height="auto" variant="top" src={item.game_page ? item.game_page.background_image_url : ''} />
                                <Card.ImgOverlay>
                                    <img style={{
                                        borderRadius: 5,
                                        borderWidth: 5,
                                        borderColor: "white",
                                        backgroundColor: "white",
                                        paddingTop: 2,
                                        paddingLeft: 2,
                                        paddingBottom: 2,
                                        paddingRight: 2,
                                        marginTop: "20%"
                                    }} height="20%" src={item.game_page ? item.game_page.icon_url : ''} />
                                </Card.ImgOverlay>
                                <Card.Body>
                                    <Card.Title>
                                        {item.name}{item.status !== 'active' ?
                                        <span style={{
                                            float: "right",
                                            backgroundColor: "#ffea2b",
                                            color: "#faf19d",
                                            borderRadius: 5,
                                            fontWeight: "bold",
                                            capacity: 1,
                                            padding: 10,
                                        }}>
                                            {item.status.replace('_', ' ').replace('_', ' ')}
                                        </span>
                                        : <empty/>}
                                    </Card.Title>
                                    <Card.Text>
                                        <img src="https://cdn-icons-png.flaticon.com/512/2636/2636869.png" width="30px"/>
                                        <span style={{
                                            fontSize: 20
                                        }}>{item.es_index}</span>
                                    </Card.Text>
                                </Card.Body>
                                <ListGroup className="list-group-flush">
                                    <ListGroup.Item>{item.genre} from {item.publisher.name}</ListGroup.Item>
                                    <ListGroup.Item>Category: {item.game_category ? item.game_category.name : "none"}</ListGroup.Item>

                                    <ListGroup.Item>
                                        <NavLink
                                            to={"/games/" + item.id.toString()}
                                            style={{
                                                marginRight: 10
                                            }}
                                            className={({ isActive }) => (isActive ? 'btn btn-warning' : 'btn btn-warning')}
                                        >
                                            More
                                        </NavLink>
                                        <NavLink
                                            style={{
                                                marginRight: 10
                                            }}
                                            className={({ isActive }) => (isActive ? 'btn btn-primary' : 'btn btn-primary')}
                                        >
                                            <TwitterShareButton
                                                url={"https://easy-street.herokuapp.com/games/" + item.id.toString()}
                                                quote={item.name}
                                                hashtag="#easystreet"
                                            >
                                                Share
                                            </TwitterShareButton>
                                        </NavLink>
                                        <NavLink
                                            to={"/games/" + item.id.toString()}
                                            className={({ isActive }) => (isActive ? 'btn btn-success' : 'btn btn-success')}
                                        >
                                            Download
                                        </NavLink>
                                    </ListGroup.Item>
                                </ListGroup>
                            </Card>
                            <br/><br/>
                        </div>
                    ))}
                </div>
            );
        }

        return <Container>
            <Row>
                <Col>
                    {content}
                </Col>
            </Row>
        </Container>;
    }
}

export default withRouter(Genre);
